module.exports = __webpack_public_path__ + "img/spritz-botanic.831d2d8b.png";